module.exports = __webpack_public_path__ + "img/top_download.16b8ce38.svg";